import type { UserInfoGenerateVO, PersonalInfoVO } from '@core/types/auto/oj';
import type {
  PersonalInfo,
  PreferenceInfo,
  UpdateUserRequestVO,
  UserVO,
} from '@core/types/user';
import { GATEWAY_PREFIX_COMMON } from '@core/utils/runtime-config'
import { httpService } from './http';

export function getSignInUserInfo(loginSource?: string, adtag?: string) {
  return httpService.get<UserVO>(`${GATEWAY_PREFIX_COMMON}/api/get-user-info`, {
    query: { loginSource, adtag, distinguish: 1 },
  });
}

export function fillUserInfo(data: UpdateUserRequestVO) {
  return httpService.post<UserVO>(`${GATEWAY_PREFIX_COMMON}/api/fill-user-info`, {
    body: data,
    headers: httpService.COMMON_HEADERS,
  });
}

export function bindPhoneNumber(data: UpdateUserRequestVO) {
  return httpService.post<UserVO>(`${GATEWAY_PREFIX_COMMON}/api/bind-user-phone`, {
    body: data,
    headers: httpService.COMMON_HEADERS,
  });
}

export function getPersonalInfo() {
  return httpService.get<PersonalInfoVO>(`/api/code-community/api/get-personal-info`);
}

export function personalInfoSet(data: PersonalInfoVO) {
  return httpService.post(`/api/code-community/api/personal-info-set`, {
    body: data,
  });
}

export function preferenceInfoSet(data: PreferenceInfo) {
  return httpService.post(`/api/code-community/api/preference-info-set`, {
    body: data,
  });
}

export function setUserDefault() {
  return httpService.post(`/api/code-community/api/set-user-default`, {});
}

export function setUserNickname(data: {
  avatar: string;
  nickname: string;
  uid: string;
}) {
  return httpService.post(`/api/code-community/api/set-user-nickname`, {
    body: data,
  });
}

export function generateUserInfo() {
  return httpService.post<UserInfoGenerateVO>(
    `/api/code-community/api/generate-user-info`,
    {},
  );
}

// 收集用户的编程水平
export function gatherCodeLevel(data: { codeLevel: number }) {
  return httpService.post(`/api/code-community/api/gather-code-level`, {
    body: data,
  });
}

// 判断当前用户是否是在课用户
export function getYsInClass() {
  const url = `/api/code-community-actuator/api/common/get-ys-in-class`;
  return httpService.get<boolean>(url);
}
